module.exports = __webpack_public_path__ + "06_short_gold.94cefd72.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/06_short_gold.png
// module id = YJtv
// module chunks = 0